module.exports = __webpack_public_path__ + "img/just.4814ce95.png";